import type { CacheMessageType } from "@remi/types/socket/message";

export type CacheChannelProps = {
  entityType: CacheMessageType;
  entityId: string | number;
};

export const getCacheChannelName = (entityType: CacheMessageType, entityId: string | number) => {
  return `cache-${entityType.toLowerCase()}:${entityId}`;
};
